<div class="delivery-closed-container">
	<img class="delivery-closed-close" src="../../../assets/images/close-icon.png" alt=""
		(click)="activeModal.close()" />
	<div class="delivery-closed-title">
        <b>{{ restaurant.name }}</b>
        <br>
		<span [innerHTML]="isCurrentlyOpen ? 
		('noDeliveryModal.temporarilyClosed' | transloco : { type: orderType })
		: ('noDeliveryModal.currentlyClosed' | transloco : { type: orderType })"></span>
	</div>
	<div class="delivery-hours">
		<div class="delivery-closed-hours-title" [innerHTML]="'noDeliveryModal.deliveryHours' | transloco : { type: orderType }"></div>
        @for (day of masterSchedule; track $index; let i = $index) {
            <div class="delivery-closed-hours-container">
                <div class="delivery-closed-day">
                    {{ 'common.weekdays.' + i | transloco }}
                </div>
    
                <div class="restaurant-about-important-hours-dropdown-time-container">
                    @if (checkSchedule(day)) {
                        <div class="restaurant-about-important-hours-dropdown-time">
                            {{ 'noDeliveryModal.closed' | transloco }}
                        </div>
                    } @else {
                        @for (hour of parseHours(day); track $index) {
                            <div class="restaurant-about-important-hours-dropdown-time">
                                {{ hour }}
                            </div>
                        }
                    }
                </div>
            </div>
        }
	</div>
</div>
